import * as weatherApi from './weather-api';

/**
 * The "Weather Client" is a place for normalizing, error handling, logging, and tracking.
 */

export const setApiOrigin = weatherApi.setApiOrigin;

export function fetchCurrentConditions(latitude, longitude) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return weatherApi.fetchCurrentConditions(latitude, longitude);
}

export function fetchAirQuality(latitude, longitude) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return weatherApi.fetchAirQuality(latitude, longitude);
}

export function fetchAlerts(latitude, longitude) {
	if (!latitude || !longitude) {
		return Promise.reject('The latitude or longitude parameter is missing');
	}

	return weatherApi.fetchAlerts(latitude, longitude);
}
